import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-rating-star-icon',
  templateUrl: './rating-star-icon.component.html',
  styleUrls: ['./rating-star-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingStarIconComponent {}
